import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type { EInvoicePreviewResponse } from "~/modules/billing/api/eInvoice/eInvoiceTypes.ts";
import type {
	CreateInvoiceDocumentResponseType,
} from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";

const eInvoicesBasePath = (invoiceId: string) => `invoices/${invoiceId}/e-invoice`;

export function showEInvoicePreview(invoiceId: string): AxiosApiResponsePromise<EInvoicePreviewResponse> {
	return axiosApi.get(eInvoicesBasePath(invoiceId) + "/preview");
}

export function generateEInvoiceFile(invoiceId: string): AxiosApiResponsePromise<CreateInvoiceDocumentResponseType> {
	return axiosApi.get(eInvoicesBasePath(invoiceId));
}